import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ConfigurationService } from "app/shared/services/configuration.service";
import { NotificationService } from "app/shared/services/notification.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-cookie-notice",
  templateUrl: "./cookie-notice.component.html",
  styleUrls: ["./cookie-notice.component.scss"],
})
export class CookieNoticeComponent implements OnInit {
  @Output() toggle = new EventEmitter();
  notificationSub: Subscription;
  identityUrl: string;

  constructor(
    private notificationService: NotificationService,
    private configurationService: ConfigurationService
  ) {
    this.identityUrl = this.configurationService.serverSettings.identityUrl;
  }

  ngOnInit() {}

  onClose() {
    this.notificationService.cookiePolicyConfirmClose();
    this.toggle.emit(false);
  }
}
